import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONSTANSTS } from '@core/constants';
import { FacilityListModel } from '@shared/models/facility.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FacilitiesService {

  constructor(private readonly http: HttpClient) { }

  /**
   * tesis kombosunu doldurmak için kısıtlı tesis bilgilerini çekiyoruz.
   */
  getFacilityNames(): Observable<FacilityListModel[]> {
    return this.http.get<FacilityListModel[]>(CONSTANSTS.api.facilities.getFacilityNames)
      .pipe(
        map((facilities: FacilityListModel[]) => {
          return facilities;
        }));
  }

}
